import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import "react-datepicker/dist/react-datepicker.css";

export default function InputField({ register, name, errors, field, ...rest }) {
  return (
    <Stack sx={{ margin: "1rem" }}>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
      </Typography>
      <TextField
        {...register(field.name)}
        {...rest}
        error={errors[field.name] ? true : false}
        helperText={errors[field.name] ? errors[field.name].message : ""}
        color="primary"
        size="small"
        defaultValue={field.default ? field.default : ""}
        sx={{
          width: "100%",
          margin: "unset",
        }}
      />
    </Stack>
  );
}
